module.exports = __webpack_public_path__ + "img/arrow-right-pri.17847739.svg";